(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDetailController",
            WorkOrderTypeDetailController
        );

    WorkOrderTypeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkOrderType",
        "User",
    ];

    function WorkOrderTypeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkOrderType,
        User
    ) {
        var vm = this;

        vm.workOrderType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workOrderTypeUpdate",
            function (event, result) {
                vm.workOrderType = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();
